
(function() {

    var _uim = function() {

        var recorder = new uimetrics.Recorder();
        recorder.init();
        return recorder;

    };

    UIM = _uim();

})();
